export default "__VITE_PUBLIC_ASSET__4e54a6aa__"